import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { listRecentEarthquakes } from '../api/earthquakes'
import { qk } from '../lib/query-keys'
import { deriveAlertPhase, type AlertPhase } from '../lib/alert-phase'
import { useWaveStore } from '../stores/wave'

/**
 * 全局警报相位：波传播 store + 最近事件查询合并推导。
 * 复用 recentQuakes(20) 查询缓存，与 RecentQuakeList 共享数据。
 */
export function useAlertPhase(): AlertPhase {
  const wave = useWaveStore((s) => s.wave)
  const quakesQuery = useQuery({
    queryKey: qk.recentQuakes(20),
    queryFn: () => listRecentEarthquakes(20),
    refetchInterval: 30_000,
    retry: 1,
  })
  return useMemo(
    () => deriveAlertPhase(wave, quakesQuery.data ?? []),
    [wave, quakesQuery.data],
  )
}
